/* eslint-disable react-hooks/exhaustive-deps */
import { message } from 'antd';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  useEffect(() => {
    message.success('Payment successful, thank you!', 5);
    navigate('/');
  }, []);
  return <></>;
};

export default PaymentSuccess;
